// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/
// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.
// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx
import baseIcon from '@bubble-ui/temp-icon-base';
var IconHelpPath = 'M1 3c0-1.654 1.346-3 3-3h15v14c0 1.654-1.346 3-3 3H6.125c-1 0-1.966.295-2.796.853L1 19.422V3zm15 12c.551 0 1-.448 1-1V2H4c-.551 0-1 .448-1 1v12.734A6.993 6.993 0 016.125 15H16zm-4.5-2.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.958 6.587h2c0-.136.117-.254.187-.312.215-.181.631-.34 1.162-.248.423.076.676.319.72.467v.002c.017.058.054.19-.138.374l-.977.974A3.002 3.002 0 009 10l2-.039c0-.248.111-.49.322-.699l.969-.965c.659-.64.903-1.526.654-2.369-.277-.938-1.175-1.672-2.288-1.869-1.025-.184-2.07.074-2.797.683-.581.487-.902 1.143-.902 1.845z';
var IconHelp = baseIcon('IconHelp', {
  getPath: function getPath() {
    return IconHelpPath;
  }
});
export default IconHelp;
//# sourceMappingURL=index.js.map